import { render, staticRenderFns } from "./Coverage.vue?vue&type=template&id=74f2767a&"
import script from "./Coverage.vue?vue&type=script&lang=js&"
export * from "./Coverage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports